<template>
  <div class="ruleCard">
    <div class="header g-flex-sb">
      <span class="rule-num">规则{{nums[index]}}</span>
      <div>
        <slot></slot>
      </div>
    </div>
    <div class="content">
      <el-row>
        <el-col class="title" :span="5">活动时间</el-col>
        <el-col class="content" :span="19">{{dayjs(data.startTime).format('YYYY-MM-DD')}} ~ {{dayjs(data.endTime).format('YYYY-MM-DD')}}</el-col>
      </el-row>
      <el-row>
        <el-col class="title" :span="5">选择生效天</el-col>
        <el-col class="content" :span="19" >
          <template v-if="data.days.constructor === Array">
            {{data.days.map(item => weekDay[item - 1]).join('，')}}
          </template>
          <template v-else>
            {{data.days.split(',').map(item => weekDay[item - 1]).join('，')}}
          </template>
        </el-col>
      </el-row>
      <el-row v-if="activeType === 9">
        <el-col class="title" :span="5">每日活动时间</el-col>
        <el-col class="content" :span="19">
          <template v-if="data.activeTimes.constructor == Array">
            <span v-for="(item, index) in data.activeTimes" :key="index">
              {{`${item[0]}-${item[1]}`}}
              <span v-if="index !== data.activeTimes.length  - 1">、</span>
            </span>
          </template>
          <template v-else>
            {{data.activeTimes}}
          </template>
        </el-col>
      </el-row>
      <el-row>
        <el-col class="title" :span="5">用户类型</el-col>
        <el-col class="content" :span="19">{{userTypeList.find(item => item.value === data.userType).label}}</el-col>
      </el-row>
      <el-row>
        <el-col class="title" :span="5">活动油号</el-col>
        <el-col class="content" :span="19"><b>{{data.oilNo}}#油品</b>  追加让利{{data.rebate ? data.rebate + '%' : '--'}} 
          <!-- 降价参考 <span class="reductionAmount">{{data.reductionAmount}}</span> 元/升 -->
        </el-col>
      </el-row>
      <!-- <el-row>
        <el-col class="title" :span="5">是否资源位置顶</el-col>
        <el-col class="content" :span="19">{{data.isLocationTop ? `${data.distance}KM`: '否'}}</el-col>
      </el-row> -->
      <el-row>
        <el-col class="title" :span="5">投放渠道</el-col>
        <el-col class="content" :span="19">{{pushChannelList[data.pushChannel]}}</el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
const nums = ['一', '二', '三', '四', '五', '六']
import config from './config'
import dayjs from 'dayjs'

export default {
  name: 'ruleCard',
  props: ['data', 'index', 'activeType'],
  data () {
    return {
      nums,
      ...config
    }
  },
  methods: {
    dayjs
  }
}
</script>
<style lang="less" scoped>
  @import url('./ruleCard.less');
</style>